import axios from "@/libs/api.request";
// 获取应收报表列表
export const getBackWarehouse = params => {
  return axios.request({
    url: "/statistics/getBackWarehouse",
    method: "get",
    params
  });
};

export const getBackWarehouseAwb = params => {
  return axios.request({
    url: "/statistics/getBackWarehouseAwb",
    method: "get",
    params
  });
};
